/**************************************************************************************************/
/*   File: /src/app/shared/models/ambito.ts                                                       */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 12th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The ambito
 */
export class Ambito {
    /**
     * The value
     */
    value: string;
    /**
     * The name
     */
    name: string;
    /**
     * The ambito territoriale type
     */
    ambitoTerritorialeType: number;
}